import { defineStore } from 'pinia';
import axios from 'axios';

export const useAppStore = defineStore('app', {
    state: () => ({
        is_loading: false,
        form_error_message: null,
        location: 'Creve Coeur',
        all_locations: [
            'TPF',
            'Creve Coeur',
            'Maplewood',        
            'Fenton',
            'Lake Saint Louis',
          ],
        location_permissions: null,
        chosen_user_id: null,
        chosen_user_name: null,
        form: null
    }),
    getters: {
        locations() {
            return Array.isArray(this.location_permissions) && this.location_permissions.length > 0 
            ? this.location_permissions.filter(loc => this.all_locations.includes(loc)) // Filter only valid locations
            : this.all_locations;
        }
    },
    actions: {
        async refreshLocationPermissions() {
            try {
                const oldPermissions = JSON.stringify(this.location_permissions);
                const response = await axios.get("/api/location_permissions?refresh=true");
                const newPermissions = response.data;
                this.location_permissions = newPermissions;
                
                // Check if permissions actually changed (WordPress returned new data)
                const permissionsChanged = JSON.stringify(newPermissions) !== oldPermissions;
                
                // Check if the current location is still valid among the fetched permissions
                if (this.location) {
                    const is_valid_location = this.locations.some(permission => permission === this.location);
                    if (!is_valid_location) {
                        // Reset location if it's no longer valid
                        this.location = this.locations.length > 0 ? this.locations[0] : null;
                    }
                } else if (this.locations.length > 0) {
                    // If no location is set, default to the first one
                    this.location = this.locations[0];
                }
                
                // Return object with success status and whether permissions were actually refreshed
                return { success: true, refreshed: permissionsChanged };
            } catch (error) {
                console.error("Error refreshing location permissions:", error);
                return { success: false, refreshed: false };
            }
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'app-store',
                storage: localStorage,
            },
        ],
    },
});